import {TPT_FAILED, RECEIVE_TPT, REQUEST_TPT} from "../actions/types";

function tptRequest(state = {}, action) {
  switch(action.type) {
    case RECEIVE_TPT:
      return Object.assign({}, state, {
        isFetching: false,
        tpt: action.tpt
      });
    case REQUEST_TPT:
      return Object.assign({}, state, {
        isFetching: true,
        tpt: []
      });
    case TPT_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        tpt: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}

export default tptRequest;
